export default "__VITE_ASSET__wSJNa5Tl__"